// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeExam = {
  examAuthInvalidRefreshToken: "ログインセッションが無効になりました。再度ログインしてください",
  examAuthAccountLocked: "アカウントはロックされています。しばらくしてから再試行してください",
  examAuthCredentialsInvalid: "ユーザー名またはパスワードが正しくありません",
  examAuthCaptchaRequired: "ログイン前に captcha の確認が必要です",
  examAuthCaptchaInvalid: "captcha が正しくありません",
  examAuthIpNotAllowed: "現在の IP {ip} はログイン許可範囲外です",
  examAuthPasswordReuseDisallowed: "新しいパスワードは現在のパスワードと同じにできません",
  examAuthCurrentPasswordIncorrect: "現在のパスワードが正しくありません",
  examAuthPermissionDenied: "この操作を行う権限がありません",
  examScoringAttemptNotFound: "解答 #{attempt_id} が見つかりません",
  examExamNotFound: "試験 #{exam_id} が見つかりません",
  examExamCodeNotFound: "試験コード {exam_code} が見つかりません",
  examExamCodeRequired: "試験コードが必要です",
  examEntryRequired: "試験のエントリーコードまたはサブドメインが必要です",
  examEntryNotFound: "試験エントリーが見つかりません",
  examEntryCodeConflict: "試験エントリーコードはすでに使用されています",
  examEntrySubdomainConflict: "試験エントリーサブドメインはすでに使用されています",
  examExamFieldInvalid: "試験フィールド {field} が無効です",
  examExamStatusUpdateForbidden:
    "試験ステータスを {current_status} から {requested_status} に変更するにはステータス操作を使用してください",
  examExamArchivedEditForbidden: "試験 #{exam_id} はアーカイブ済みのため編集できません",
  examExamPaperVersionChangeForbidden:
    "試験 #{exam_id} には解答があるため試験問題の版を変更できません",
  examExamCandidateAssignmentForbidden: "この試験には受験者を割り当てられません",
  examExamUnsupportedStatusAction: "この試験ステータス操作はサポートされていません",
  examExamStatusTransitionInvalid:
    "試験 #{exam_id} は現在の状態 {current_status} では {action} を実行できません",
  examExamAssignedCandidatesRequired:
    "試験 #{exam_id} で {action} を実行する前に受験者を割り当ててください",
  examExamDurationRequired: "試験 #{exam_id} には 0 より大きい試験時間が必要です",
  examExamRunningAttemptsExist: "試験 #{exam_id} には進行中の解答があるためアーカイブできません",
  examExamRequiresEndedStatus: "試験 #{exam_id} の成績を公開するには試験を終了する必要があります",
  examExamDeleteRequiresDraft: "試験 #{exam_id} はドラフト状態の場合のみ削除できます",
  examExamHasAttemptRecords: "試験 #{exam_id} には解答記録があるため削除できません",
  examCandidateUserNotFound: "受験者ユーザー #{candidate_id} が見つかりません",
  examCandidateUserInvalid: "受験者ユーザー #{candidate_id} は無効です: {reason}",
  examCandidateNotAssigned: "受験者 #{candidate_id} は試験 #{exam_id} に割り当てられていません",
  examCandidateHasAttempt: "受験者 #{candidate_id} には試験 #{exam_id} の解答記録があります",
  examStaffUserNotFound: "スタッフユーザー #{staff_user_id} が見つかりません",
  examStaffUserInvalid: "スタッフユーザー #{staff_user_id} は無効です: {reason}",
  examStaffAssignmentNotFound:
    "試験 #{exam_id} にスタッフユーザー #{staff_user_id} の割り当てがありません",
  examRuntimeDataContractInvalid: "試験ランタイムのデータ契約が無効です",
  examRuntimeExportDependencyMissing: "試験ランタイムのエクスポート依存関係を利用できません",
  examExamForbidden: "試験 #{exam_id} にアクセスする権限がありません",
  examAttemptNotFound: "解答 #{attempt_id} が見つかりません",
  examAttemptForbidden: "解答 #{attempt_id} にアクセスする権限がありません",
  examAttemptQuestionNotFound: "解答設問 #{attempt_question_id} が見つかりません",
  examUserValidationFailed: "ユーザーデータが無効です",
  examUserDataContractInvalid: "ユーザーデータの契約が無効です",
  examCandidateImportValidationFailed: "受験者インポートデータが無効です",
  examCandidateImportDependencyUnavailable:
    "受験者インポートまたはテンプレート出力の依存関係を利用できません",
  examCandidateImportTemplateGenerationFailed: "受験者インポートテンプレートを生成できませんでした",
  examQuestionNotFound: "題目 #{question_id} が見つかりません",
  examQuestionCodeNotFound: "問題コード {question_code} が見つかりません",
  examQuestionVersionNotFound: "題目 #{question_id} の版が見つかりません",
  examQuestionValidationFailed: "問題データが無効です",
  examQuestionStateConflict:
    "問題 #{question_id} は現在の状態 {current_status} では {action} を実行できません",
  examQuestionInUse: "問題 #{question_id} は {reference_type} から参照されているため削除できません",
  examCustomFieldValidationFailed: "カスタム項目のデータが無効です",
  examCustomFieldNotFound: "カスタム項目の定義または関連リソースが見つかりません",
  examEnvironmentPracticalSessionQuestionTypeNotSupported:
    "問題 #{question_id} の種類 {question_type} は体験セッションに対応していません",
  examEnvironmentPracticalSessionContainerIdRequired: "コンテナ ID が必要です",
  examEnvironmentFlagValidationQuestionTypeNotSupported:
    "問題 #{question_id} の種類 {question_type} はフラグ検証に対応していません",
  examEnvironmentFlagValidationActiveInstanceRequired:
    "設問 #{attempt_question_id} にアクティブな環境インスタンスがありません",
  examEnvironmentFlagValidationInstanceDestroyed:
    "環境インスタンス #{instance_id} は破棄されているためフラグを検証できません",
  examEnvironmentCallbackInstanceDestroyed:
    "環境インスタンス #{instance_id} は破棄されているためコールバックを受け付けられません",
  examEnvironmentCallbackTokenMismatch: "環境コールバックトークンが無効です",
  examEnvironmentCallbackTokenRequired: "環境コールバックトークンが必要です",
  examEnvironmentInstanceQuestionTypeNotSupported:
    "問題 #{question_id} の種類 {question_type} は環境実行に対応していません",
  examEnvironmentInstanceCreationLimitExceeded:
    "設問 #{attempt_question_id} の環境作成回数が上限 {max_create_count} に達しました",
  examEnvironmentInstanceImageRequired: "{question_type} の環境インスタンスにはイメージが必要です",
  examEnvironmentInstanceContainerPortInvalid:
    "{question_type} の環境インスタンスのコンテナポートが無効です",
  examEnvironmentInstanceInitScriptUnsupported:
    "{question_type} のコンテナブラックボックス環境では初期化スクリプトを使用できません",
  examEnvironmentInstanceDataContractInvalid:
    "環境インスタンスの永続化データ契約が無効です（フィールド: {field}）",
  examEnvironmentNodeRuntimeRequestFailed: "ノードランタイムへのリクエストに失敗しました",
  examEnvironmentNodeRuntimeUnavailable: "ノードランタイムを利用できません",
  examEnvironmentNodeRuntimeDataContractInvalid:
    "ノードランタイムのデータ契約が無効です（操作: {operation}、フィールド: {field}）",
  examEnvironmentExecutionFabricConfigurationMissing:
    "Execution Fabric の設定が不足しています（フィールド: {field}）",
  examEnvironmentCandidateConcurrentLimitExceeded:
    "実行中の環境数 {active_count} が上限 {max_active_count} に達しました",
  examEnvironmentCandidateTotalCreationLimitExceeded:
    "環境作成総数 {total_count} が上限 {max_total_count} に達しました",
  examEnvironmentEvaluationInstanceDestroyed:
    "環境インスタンス #{instance_id} は破棄されているため自己チェックを実行できません",
  examEnvironmentEvaluationSelfCheckDisabled:
    "現在の試験では解答設問 #{attempt_question_id} の自己チェックは無効です",
  examEnvironmentEvaluationSelfCheckLimitExceeded:
    "解答設問 #{attempt_question_id} の自己チェック上限 {max_self_check_count} 回に達しました（使用済み {used_self_check_count} 回）",
  examEnvironmentEvaluationDataContractInvalid:
    "環境インスタンス #{instance_id} の評価データ契約が無効です（フィールド: {field}）",
  examEnvironmentEvaluationLocalWorkspaceUnavailable:
    "環境インスタンス #{instance_id} のローカル作業ディレクトリを利用できません。環境を再作成してから再試行してください",
  examEnvironmentDockerInstanceImageRequired: "Docker インスタンスのイメージ名が必要です",
  examEnvironmentDockerInstanceContainerIdRequired: "Docker インスタンス ID が必要です",
  examEnvironmentDockerInstanceDataContractInvalid:
    "Docker インスタンスサービスの応答形式が不正です",
  examEnvironmentTaskCenterExecutionCenterRequired:
    "このタスクセンター操作には実行センターモードが必要です",
  examEnvironmentTaskCenterHandoffFailed:
    "タスクセンターへのリクエストに失敗しました。しばらくしてから再試行してください",
  examEnvironmentTaskCenterDataContractInvalid: "タスクセンターの応答形式が不正です",
  examEnvironmentOrchestratorHandoffFailed:
    "環境インスタンスの破棄要求をオーケストレーターに送信できませんでした",
  examEnvironmentDockerImageImageRequired: "イメージ名が必要です",
  examEnvironmentDockerImageNotFound: "イメージが見つかりません: {image}",
  examEnvironmentDockerImageDataContractInvalid: "Docker イメージサービスの応答形式が不正です",
  examEnvironmentDockerImageExecutionCenterRequired:
    "この Docker イメージ操作には実行センターモードが必要です",
  examEnvironmentDockerImageDefaultPortInvalid: "デフォルトポートが無効です",
  examEnvironmentDockerImageDefaultPortNotDeclared:
    "デフォルトポートが選択したイメージの宣言ポートにありません",
  examEnvironmentDockerImageArchiveNotFound: "Docker イメージアーカイブが見つかりません",
  examEnvironmentDockerImageArchiveInvalid:
    "Docker イメージアーカイブは有効な tar ファイルである必要があります",
  examEnvironmentDockerImageArchiveTooLarge:
    "Docker イメージアーカイブが {max_bytes} バイトの制限を超えています",
  examEnvironmentDockerImageAssetImportFailed:
    "アセットセンターからの Docker イメージのインポートに失敗しました",
  examEnvironmentDockerImageDockerfileRequired: "Dockerfile の内容が必要です",
  examEnvironmentDockerImageDockerfileTooLarge:
    "Dockerfile が {max_bytes} バイトの制限を超えています",
  examEnvironmentDockerImageBuildTimeout: "Docker イメージのビルドがタイムアウトしました",
  examEnvironmentDockerImageRuntimeUnavailable: "Docker ランタイムを利用できません",
  examEnvironmentDockerImageBuildFailed: "Docker イメージのビルドに失敗しました",
  examJudgeDataContractInvalid: "判定データの形式が不正です: {field}",
  examJudgeQuestionTypeNotSupported:
    "題目 #{question_id} の種類 {question_type} は {operation} に対応していません",
  examJudgeSourceCodeNotFound: "解答設問 #{attempt_question_id} の判定用コードが見つかりません",
  examJudgeRuntimeUnavailable: "{language} の判定実行環境を利用できません",
  examJudgeUnsupportedLanguage: "判定は {language} に対応していません",
  examJudgeSubmissionNotFound: "解答設問 #{attempt_question_id} の判定記録が見つかりません",
  examJudgeServiceRequestFailed: "判定サービスのリクエストに失敗しました",
  examJudgeServiceUnavailable: "判定サービスを利用できません",
  examJudgeServiceInvalidResponse: "判定サービスの応答が不正です",
  examReviewObjectiveQuestionNotReviewable: "客観题 #{question_id} は手動レビューできません",
  examPlatformApplicationNotFound: "アプリケーション {app_key} が見つかりません",
  examEnvironmentInstanceNotFound: "環境インスタンス #{instance_id} が見つかりません",
  examScoringScoresUnavailable: "解答 #{attempt_id} の成績はまだ表示できません",
} as const;
